import gP1_img from './goat01.webp'
import gP2_img from './goat02.webp'
import gP3_img from './goat03.png'
import gP4_img from './goaT.webp'
import sP1_img from './sheep01.jpg'
import cP1_img from './cow01.jpg'
import cP2_img from './cow02.avif'
import cP3_img from './cow03.jpg'
import cP4_img from './cow04.jpg'
import cM1_img from './camel01.jpeg'
import cM2_img from './camel02.webp'
import cM3_img from './camels001.jpeg'

let data_product = [
    {
        id:1,
        name:'Boer Goat', 
        category:"goats",
        image:gP1_img,
        newPrice:10000,
        oldPrice:11000,
        info: "Known for their rapid growth and excellent meat quality, Boer goats are a top choice for commercial farming. They're robust and highly adaptable.",
    },
    {
        id:2,
        name:'Boran Goat',
        category:"goats",
        image:gP2_img,
        newPrice:9500,
        oldPrice:10000,
        info: "deal for meat production, offering good yields in challenging environments.",
    },
    {
        id:3,
        name:'Turkana Goat',
        category:"goats",
        image:gP3_img,
        newPrice:10000,
        oldPrice:12000,
        info: "This native breed from Turkana is celebrated for its extraordinary hardiness and ability to withstand harsh climates, making it perfect for sustainable local farming.",
    },
    {
        id:4,
        name:'Dairy Goat',
        category:"goats",
        image:gP4_img,
        newPrice:9000,
        oldPrice:11000,
        info: "High-producing dairy goats, selected for their consistent milk yield and calm temperament. An excellent addition for a reliable and fresh milk supply.",
    },
    {
        id:5,
        name:'Sheep', // Consider being more specific if there's a particular breed, e.g., 'Dorper Sheep'
        category:"sheeps",
        image:sP1_img,
        newPrice:9500,
        oldPrice:10000,
        info: "These sheep are both robust and adaptable, prized for their quality meat and manageable nature. Suitable for various grazing conditions, they are a solid choice for livestock.",
    },
    {
        id:6,
        name:'Boran Cow',
        category:"cows",
        image:cP1_img,
        newPrice:75000,
        oldPrice:80000,
        info: "Excellent for consistent meat production.",
    },
    {
        id:7,
        name:'Dairy Cow', // If you have multiple dairy cow types, consider specifying the breed
        category:"cows",
        image:cP2_img,
        newPrice:70000,
        oldPrice:70000,
        info: "A high-yielding dairy cow offering significant and consistent milk production. Ideal for commercial dairy operations focusing on efficiency and output.",
    },
    {
        id:8,
        name:'Dairy Cow',
        category:"cows", // Changed to lowercase 'cows' for consistency with other categories
        image:cP4_img,
        newPrice:50000,
        oldPrice:55000,
        info: "Another reliable dairy cow, noted for its adaptability and steady milk production. A valuable asset for small to medium-scale dairies and mixed farms.",
    },
    {
        id:9,
        name:'North Eastern Camel',
        category:"camels",
        image:cM2_img,
        newPrice:90000,
        oldPrice:100000,
        info: "Known for their exceptional endurance and ability to traverse vast distances in arid regions. These camels are vital for transport and offer milk production in dry climates.",
    },
    {
        id:10,
        name:'Turkana Camel',
        category:"camels",
        image:cM1_img,
        newPrice:100000,
        oldPrice:120000,
        info: "A highly sought-after camel breed from the Turkana region, renowned for its incredible strength, resilience, and unparalleled adaptability to extreme desert conditions.",
    },
    {
        id:11,
        name:'Camels', // Consider being more specific, e.g., 'Young Dromedary Camel'
        category:"camels",
        image:cM3_img,
        newPrice:90000,
        oldPrice:95000,
        info: "Versatile and robust camels, perfectly suited for various purposes including transport, milk, and meat. They are a fundamental asset for pastoralist livelihoods.",
    },
    {
        id:12,
        name:'Bulls', // Consider specifying breed, e.g., 'Boran Bull' or 'Shorthorn Bull'
        category:"cows", // Kept in 'cows' category as bulls are male cattle, but 'cattle' could also be an option
        image:cP3_img,
        newPrice:100000,
        oldPrice:105000,
        info: "Strong and healthy bulls, essential for breeding programs to enhance herd genetics and improve overall productivity. A crucial addition for robust livestock farming.",
    }
]
export default data_product;